import type { FC } from 'react';

import Tooltip from 'app/components/Tooltip';

interface Props extends ClassNameProp {
  label: string;
  Icon: SVG;
  iconClassName?: string;
}

const IconWithTooltip: FC<Props> = ({ Icon, label, className, iconClassName }) => (
  <Tooltip content={label} className={className} active={label.length > 0}>
    <Icon className={iconClassName} />
  </Tooltip>
);

IconWithTooltip.displayName = 'IconWithTooltip';

export default IconWithTooltip;
